import { render, staticRenderFns } from "./ColumnLineTaxType.vue?vue&type=template&id=360062b0"
import script from "./ColumnLineTaxType.vue?vue&type=script&lang=js"
export * from "./ColumnLineTaxType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports